/**
 * Always reports an error through the provided callback.
 * @param {unknown} error
 * @param {Function} reporter - Callback that sends the error to the monitor (Sentry).
 */
export const reportErrorOnce = (error, reporter) => {
  if (!error || typeof error !== 'object') {
    reporter?.()
    return
  }

  reporter?.()
}
